import script from "./SkillsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsModal.vue?vue&type=script&setup=true&lang=js"

import "./SkillsModal.vue?vue&type=style&index=0&id=e7c82508&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c82508"]])

export default __exports__